import {Message, MessageBox} from 'element-ui';
import Vue from 'vue'

export default {
  //根据角标获取字典值
  getArrayValue(dict, index) {
    for (let i = 0; i < dict.length; i++) {
      if (i == index) {
        return dict[i].value
        break;
      }
    }
  },
};
  //获取图片完整路径
  Vue.prototype.formatUrl = function (url) {
    if (url != null && url != undefined && url != "") {
      if (url.indexOf("http") > -1) {
        return url
      } else {
        let fileBasePath = this.$store.getters.config.fileBasePath;
        return fileBasePath + "/" + url
      }
    }
  }
  //是否移动端
  Vue.prototype.isMobile = function () {
    let flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    console.log(flag == null?false:true);
    return flag == null?false:true;
  },

  //过滤文本信息
  Vue.prototype.formatText = function (content) {
    return content.replace(/<[^>]+>/g,"");  //正则去掉所有的html标记
  },

  //跳转页面
  Vue.prototype.toPage = function (option) {
    this.$router.push(option)
  }

  //清空对象值
  Vue.prototype.resetForm = function (refForm) {
    if (refForm) {
      refForm.resetFields();
    }
  };
  Vue.prototype.resetFields = function (obj) {
    for (let key in obj) {
      if (obj[key] instanceof Array) {
        obj[key] = [];
      } else {
        obj[key] = "";
      }
    }
    return obj
  };
  //去除前后空格
  String.prototype.trim = function () {
    return this.replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, "");
  }

  Array.prototype.contain = function (e) {
    for (let i = 0; i < this.length; i++) {
      if (this[i] == e) {
        return true;
      }
    }
    return false;
  }
  // 克隆集合
  Array.prototype.clone = function () {
    let a = [];
    for (let i = 0, l = this.length; i < l; i++) {
      a.push(this[i]);
    }
    return a;
  }
  Vue.prototype.showToast = function (title) {
    Message({
      message: title,
      center: true
    });
  },
  Vue.prototype.showConfirm = function (content, callBack) {
    MessageBox.confirm(content, '温馨提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: "warning"
    }).then(function () {
      if (callBack) {
        callBack()
      }
    })
  },
  Vue.prototype.showSuccess = function (title) {
    Message({
      message: title,
      type: 'success',
      center: true
    });
  },
  Vue.prototype.showWarn = function (title) {
    Message({
      message: title,
      type: 'warning',
      center: true
    });
  }
  //根据字典获取数据文本
  Vue.prototype.getDictLabel = function (dict, value) {
    for (let i = 0; i < dict.length; i++) {
      if (dict[i].dictValue == value) {
        return dict[i].dictLabel
        break;
      }
    }
  };



// WEBPACK FOOTER //
// ./src/js/config/global.js